<template>
    <div id="addsite1">
      <top-nav1 ref="TopNav1"></top-nav1>
        <!--头部-->
        <van-nav-bar style="background: #F1F1F1"  title="新增/编辑收货地址" fixed left-arrow @click-left="goBack()" >
          <van-icon slot="right" @click="onClickRight()" class="iconfont icon-zhankai"></van-icon>
        </van-nav-bar>
        <div class="van-content" style="padding-top: 56px">
          <van-cell-group style="margin: 0">
            <van-field  v-model="name" placeholder="请输入收件人名称" label="收货人姓名"  type="text"/>
            <van-field type="tel"  v-model="mobile" placeholder="为避免影响收货，请准确填写您的手机号！" label="手机号码"/>
            <!-- <van-field v-model="postcode" placeholder="此项选填" label="邮编"/> -->
            <van-field  v-model="sitedDatasName" placeholder="请选择地区" readonly label="省/市/区" @click="cityPickershow"/>
            <van-field  type="textarea" class="specific" v-model="setess"  label="详细街道地址" placeholder="请输入详细地址"/>
            <!--<van-cell >-->
              <!--<van-checkbox v-model="checked" checked-color="#4b0">设为默认</van-checkbox>-->
            <!--</van-cell >-->
          </van-cell-group>
          <van-cell-group style="width:100%;position: fixed;bottom: 0px;margin: 0" >
            <van-cell v-if="this.siteId==''" style="background: transparent;padding: 0 15px 15px 15px"><van-button  size="large" class="addSiteBtn theme-bd theme-bg radius6" @click="addDatas">添加地址</van-button></van-cell>
            <van-cell v-if="this.siteId!=''" style="background: transparent;padding: 0 15px 15px 15px"><van-button  size="large" class="addSiteBtn theme-bd theme-bg radius6" @click="comitDatas">保存地址</van-button></van-cell>
          </van-cell-group>
        </div>
        <!--地址选择弹框-->
        <City-Picker ref="CityPicker" v-on:listenSitedata="geSitedatas"></City-Picker>
    </div>
</template>

<script>
  import CityPicker from '@/pages/exchange/city'
  import TopNav1 from '../../components/topnav1'
  export default {
    name: "addsite",
    components: {
      CityPicker,TopNav1
    },
    data () {
      return {
        siteId:this.$route.query.id,
        sitedDatas:'',
        sitedDatasName:'',
        checked:false,//设为默认
        name:'',//收货人
        mobile:'',//手机号
        site:'',//省市区
        setess:'',//详细地址
        province:'',
        city:'',
        town:'',
        county:'',
        postnum:'',
        provincename:'',
        cityname:'',
        townname:'',
        countyname:'',
        postcode:'',
        gid:this.$route.query.gid
      }
    },
    methods:{
      cityPickershow:function () {
        this.$refs.CityPicker.cityPickershow()
      },
      onClickRight() {
        this.$refs.TopNav1.topnavPlay()
      },
      geSitedatas:function (datas) {
        this.province='',
          this.city='',
          this.town='',
          this.county='',
          this.provincename='',
          this.cityname='',
          this.townname='',
          this.countyname=''
        this.sitedDatasName = ''
        this.sitedDatas = datas
        if(datas[0].id != undefined){
          this.sitedDatasName += datas[0].name
          this.province = datas[0].id
          this.provincename = datas[0].name
        }
        if(datas[1].id != undefined){
          this.sitedDatasName += "-"+datas[1].name
          this.city = datas[1].id
          this.cityname = datas[1].name
        }
        if(datas[2].id != undefined){
          this.sitedDatasName += "-"+datas[2].name
          this.town = datas[2].id
          this.townname = datas[2].name
        }
        if(datas[3] != undefined){
          this.sitedDatasName += "-"+datas[3].name
          this.county = datas[3].id
          this.countyname = datas[3].name
        }else{
          this.county = ''
          this.countyname = ''
        }
      },
      goBack: function () {
        history.back(-1);
      },
      telcase: function(params) {
        
      },
      getDatas:function () {
        var isUser = localStorage.getItem("ECuser")
        var mallid=localStorage.getItem("mallid");
        var gid = localStorage.getItem("gid")
        
        this.$api.post('active/address', {id_active:this.gid,token_user:isUser}, res => {
          if(res.data.code == '100'){
            this.name = res.data.data.name
            this.mobile = res.data.data.phone
            if(res.data.data.town_str==''){
              this.sitedDatasName = res.data.data.province_str+'-'+res.data.data.city_str+'-'+res.data.data.county_str
            }else{
              this.sitedDatasName = res.data.data.province_str+'-'+res.data.data.city_str+'-'+res.data.data.county_str+'-'+res.data.data.town_str
            }
            this.setess = res.data.data.address;
            this.province = res.data.data.province;
            this.city = res.data.data.city;
            this.town =res.data.data.county;
            this.county = res.data.data.town;
            this.postnum = res.data.data.zip;
            this.provincename = res.data.data.province_str;
            this.cityname = res.data.data.city_str;
            this.townname =res.data.data.county_str;
            this.countyname = res.data.data.town_str;
            this.postcode = res.data.data.zip;
          }else{
            if(res.data.message=='token验证失败') {
              this.$dialog.confirm({
                title: '提示 ',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.$router.push({name: 'Elogin',query:{gid:this.gid}})
              }).catch(() => {
              });
            }else{
              this.$toast(res.data.message)
            }
          }
        },err=>{
          this.$toast('服务器繁忙，请稍后再试')
        })
      },
      addDatas:function () {
        var reg =  /^1\d{10}$/ ;
        var yb =  /^[0-9]{6}$/ ;
        if(this.getlen(this.name)>26){
          this.$toast('收货人姓名不能超过26个字符')
            return false
        }
        if(this.mobile==""){
          this.$toast('手机号码不能为空')
          return false
        }
        if(!reg.test(this.mobile)){
          this.$toast('请输入正确的手机号')
          return false
        }
        if(this.countyname=='请选择'||this.countyname==undefined){
          this.$toast('请选择完整地址')
          return false
        }
        // if(this.postcode!=''){
        //   if(!yb.test(this.postcode)){
        //     this.$toast('请输入6位数字邮编')
        //     return false
        //   }
        // }
        var isUser = localStorage.getItem("ECuser")
        var mallid=localStorage.getItem("mallid");
        var gid = localStorage.getItem("gid")
        var _this = this
        this.$api.post('active/address/add', {
          id_active:this.gid,token_user:isUser,name:this.name,phone:this.mobile,address:this.setess,zip:this.postcode,province:this.province,
          city:this.city,town:this.county,county:this.town,province_str:this.provincename,
          city_str:this.cityname,town_str:this.countyname,county_str:this.townname,zip:this.postnum
        }, res => {
          if(res.data.code == '100'){
            this.goBack()
          }else{
            if(res.data.message=='token验证失败') {
              this.$dialog.confirm({
                title: '提示 ',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.$router.push({name: 'Elogin',query:{gid:this.gid}})
              }).catch(() => {
              });
            }else{
              this.$toast(res.data.message)
            }
          }
        },err=>{
          this.$toast('服务器繁忙，请稍后再试')
        })
      },
    comitDatas:function () {//修改地址
      var reg =  /^1\d{10}$/ ;
      var yb =  /^[0-9]{6}$/ ;
      if(this.getlen(this.name)>26){
        this.$toast('收货人姓名不能超过26个字符')
          return false
      }
      if(this.mobile==""){
        this.$toast('手机号码不能为空')
        return false
      }
      if(!reg.test(this.mobile)){
        this.$toast('请输入正确的手机号')
        return false
      }
      if(this.countyname=='请选择'||this.countyname==undefined){
          this.$toast('请选择完整地址')
          return false
        }
      // if(this.postcode!=''){
      //   if(!yb.test(this.postcode)){
      //     this.$toast('请输入6位数字邮编')
      //     return false
      //   }
      // }
      var isUser = localStorage.getItem("ECuser")
      var mallid=localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid")
      var _this = this
      this.$api.post('active/address/update', {
        id_active:this.gid,token_user:isUser,id_address:this.siteId,name:this.name,phone:this.mobile,address:this.setess,zip:this.postcode,province:this.province,
        city:this.city,town:this.county,county:this.town,province_str:this.provincename,
        city_str:this.cityname,town_str:this.countyname,county_str:this.townname,zip:this.postnum
      }, res => {
        if(res.data.code == '100'){
          this.goBack()
        }else{
          if(res.data.message=='token验证失败') {
            this.$dialog.confirm({
              title: '提示 ',
              message: '您还未登录是否去登录？'
            }).then(() => {
              this.$router.push({name: 'Elogin',query:{gid:this.gid}})
            }).catch(() => {
            });
          }else{
            this.$toast(res.data.message)
          }
        }
      })
    },
    getlen:function(str) {
      if (str == null) return 0;
      if (typeof str != "string"){
        str += "";
      }
      return str.replace(/[^\x00-\xff]/g,"01").length;
    },
  },
    mounted () {
      if(this.siteId!=''){
        this.getDatas()
      }
      $('body').css('background','#fff')
    },
    destroyed: function () {
      $('body').css('background','#EFF3F6')
    },
  }
</script>

<style lang="less" >
  #addsite1{
    .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed{
      .van-nav-bar__title {
        text-align: center!important;
        font-weight: bold!important;
      }
    }
    .van-field{
      .van-cell__title {
        max-width: 100px;
      }
    }
    .specific{
      height: 70px;
      .van-cell__value{
        height: 48px!important;
      }
      .van-field__control{
        min-height: 55px;
      }

    }
    .van-cell {
      padding: 15px 25px;
      box-sizing: border-box;
    }
    .van-cell:not(:last-child)::after {
      border-bottom-width: 1px;
    }
    .van-cell--required::before {
      content: '*';
      left: 15px;
      right: 15px;
      font-size: 14px;
      color: #f44;
      top:13px;
    }
    .van-radio{
      height: 22px;
    }

    .van-cell-group{
      background-color: #fff;
    }
    .addSiteBtn{
      background-color: #f44;
      color: #fff;
      border-right: 0;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      button{
        border-radius: 6px;
        border: none;
        width: 100%;
        float: left;
      }
    }
   .van-checkbox__icon.van-checkbox__icon--round .van-icon{
     color: #fff!important;
     border-color: #999!important;
     background-color: #999!important;
   }
    .van-cell:not(:last-child)::after {
      right: 15px;
    }
    .van-nav-bar{
      .van-icon{
        font-size: .4rem!important;
      }
    }

  }

.theme-bg,.van-checkbox--checked,.van-swipe__indicator--active{background-color:red!important;color:#ffffff!important}
.theme-col,.van-icon-checked{color: red!important;}
.col-hover:hover{color: red!important;}
.col-on{color: red!important;}
.col-focus:focus{color: red!important;}
.col-checked:checked:before{
  color: red!important;
}
</style>




// WEBPACK FOOTER //
// src/pages/exchange/addsite.vue